import * as yup from 'yup';

export const EditUserFormInputs = yup
  .object()
  .shape({
    name: yup.string().required(),
    extension: yup.string(),
    canProvideAiFeedback: yup.boolean().required(),
  })
  .required();

export type EditUserFormInputs = yup.InferType<typeof EditUserFormInputs>;
